'use strict';

require('../shared/scripts/main.js');
require('./vendor/slick.min.js');
require('./vendor/jquery.fancybox.js');
require('./product-slider.js');
require('./viewport.js');


// init accordion while live editing sections:
// see: https://help.shopify.com/themes/development/theme-editor/sections#javascript-and-stylesheet-tags
$(document).on("shopify:section:load", function() {
    $('.accordion').accordion({ singleOpen: false })
});

$(document).ready(function () {
    // initialize sliders
    $('.js-product-item-with-slider').productSlider();

    $('.js-img-fancybox').fancybox();

    $('.js-slider').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000
    });

    var index = $('.initial-slide').index()

    var $parentSlide = $('.js-slider-for');
    $parentSlide.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.js-slider-nav',
        initialSlide: index
    });

    $('.js-slider-nav').slick({
        lazyLoad: 'progressive',
        prevArrow: '<i class="product-slider-previous product-slider-arrow"><</i>',
        nextArrow: '<i class="product-slider-next product-slider-arrow">></i>',
        slidesToShow: 3,
        swipeToSlide: true,
        asNavFor: '.js-slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        initialSlide: index
    });

    // activate/deactivate sidebar on click on drawers (necessary because of the sticky header)
    var $pageContainer = $('#PageContainer');
    $('body').on('beforeDrawerOpen.timber', function() {
        if (!$pageContainer.hasClass('is-moved-by-drawer')) {
            $pageContainer.addClass('is-moved-by-drawer');
        }
    });

    $('body').on('afterDrawerClose.timber', function() {
        if ($pageContainer.hasClass('is-moved-by-drawer')) {
            setTimeout(function () {
                $pageContainer.removeClass('is-moved-by-drawer');
            }, 500);
        }
    });
});

// MOBILE DOM
function insertAtIndex($elem) {
    var $parent = $elem.data('parent');
    var index = $elem.data('index');
    if (index === 0) {
        $parent.prepend($elem);
    } else {
        $parent.children(":nth-child(" + (index) + ")").after($elem);
    }
}

// actions on viewportChange
var store = {
    'mobile': []
};
$(window).on('viewportChange', function() {
    if (viewport.isMedium || viewport.isSmall) {
        $('.js-remove-if-mobile').each(function() {
            var $elem = $(this);
            $elem.data({
                'index': $elem.index(),
                'parent': $elem.parent()
            });
            store.mobile.push($elem.detach());
        });
    } else {
        if (store.mobile.length) {
            $.each(store.mobile, function(i, $elem) {
                insertAtIndex($elem);
            });
        }
    }

    if (viewport.isLarge) {
        var $elem = $('.js-insert-if-large');
        var $placeholder = $('<div />', {
            class: 'js-inserted-if-large ' + $elem.attr('class')
        });
        $placeholder.removeClass('js-insert-if-large');
        $elem.before($placeholder);
    } else {
        $('.js-inserted-if-large').remove();
    }

    if (viewport.isXLarge) {
        var $elem = $('.js-insert-if-xlarge');
        var $placeholder = $('<div />', {
            class: 'js-inserted-if-xlarge ' + $elem.attr('class')
        });
        $placeholder.removeClass('js-insert-if-xlarge');
        $elem.before($placeholder);
    } else {
        $('.js-inserted-if-xlarge').remove();
    }

    if (viewport.isLarge || viewport.isXLarge) {
        // close sidebars if opened
        if ($('body').hasClass('js-drawer-open')) {
            timber.RightDrawer.close();
            timber.LeftDrawer.close();
            $('#PageContainer').removeClass('is-moved-by-drawer');
        }
    }
});
